import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Switch,
} from 'antd';
import moment from 'moment';
import { createFortnightly } from '../../../../appRedux/actions';
import {
  cardConfig,
  formConfig,
  buttonLabel,
  messages,
  dateFormatMx,
  placeHolders,
  dateFormat,
} from '../../../../constants';
import { CancelButton } from '../../../uiComponents';

export const FortnightlyForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState();
  const [date, setDate] = useState();

  const isMonday = useCallback((dateMoment) => {
    return dateMoment && dateMoment.day() === 1;
  }, []);

  const validateBaseWeekStartDate = useCallback(
    (_, value) => {
      if (!value) return Promise.resolve();

      const req = form.getFieldValue('requireMonday');
      if (req && !isMonday(value)) {
        return Promise.reject(new Error(messages.monday));
      }

      return Promise.resolve();
    },
    [form, isMonday]
  );

  const onExtraWeekChange = (checked) => {
    form.setFieldsValue({
      weeksCount: checked ? 53 : 52,
    });
  };

  const dateFormats = (value) => {
    const day = moment(value).format(dateFormat);
    setDate(day);
  };

  const yearRules = useMemo(
    () => [
      {
        required: true,
        message: messages.required('Año'),
      },
      { max: 4, message: messages.validation.year },
      { pattern: /^[0-9]{4}$/, message: messages.validation.invalidFormat },
    ],
    []
  );

  const onHandledSubmit = async (values) => {
    setIsLoading(true);

    const payload = {
      year: values.year?.trim(),
      baseWeekStartDate: date,
      weeksCount: values.weeksCount ?? 52,
      extraWeek: values.extraWeek ?? false,
    };

    setResponse(await dispatch(createFortnightly(payload)));
    setIsLoading(false);
  };

  useEffect(() => {
    if ([200, 201].includes(response)) {
      navigate('/dashboard/catorcenas');
    }
  }, [navigate, response]);

  return (
    <Card size="small" bordered={true} style={cardConfig}>
      <Form
        {...formConfig}
        autoComplete="off"
        onFinish={onHandledSubmit}
        form={form}
        initialValues={{
          weeksCount: 52,
          requireMonday: true,
        }}
      >
        <Form.Item name="year" label="Año" rules={yearRules}>
          <Input placeholder={placeHolders.year} />
        </Form.Item>

        <Form.Item
          name="baseWeekStartDate"
          label="Semana de inicio"
          rules={[
            {
              required: true,
              message: messages.required('Semana de inicio'),
            },
            { validator: validateBaseWeekStartDate },
          ]}
        >
          <DatePicker
            style={{ width: '100%' }}
            format={dateFormatMx}
            onChange={(object, dateString) => dateFormats(object, dateString)}
          />
        </Form.Item>

        <Form.Item
          name="extraWeek"
          label="Semana extra"
          valuePropName="checked"
        >
          <Switch onChange={onExtraWeekChange} />
        </Form.Item>

        <Form.Item name="weeksCount" label="Semanas">
          <InputNumber disabled min={1} max={60} style={{ width: '100%' }} />
        </Form.Item>

        <CancelButton path="/dashboard/catorcenas" />
        <Button
          type="primary"
          htmlType="submit"
          className="btn-form"
          loading={isLoading}
        >
          {buttonLabel.save}
        </Button>
      </Form>
    </Card>
  );
};
